export default function Page404() {
  setTimeout(() => {
    window.location.href = "/blog/";
  }, 5000);

  return (
    <div id="div-404" className="col align-self-center pt-5">
      <p className="display-3 text-center mt-5">
        <span className="text-info">404</span> | Not found
      </p>
      <br />
      <p className="text-center">
        <em>Redirecting....</em>
      </p>
    </div>
  );
}
